

export default replaceIdentifiers;
import hasOwnProp from 'utils/hasOwnProp';
function replaceIdentifiers(body, node, identifierReplacements, scope) {
	var name = node.name;
	var replacement = hasOwnProp.call(identifierReplacements, name) && identifierReplacements[name];

	// TODO unchanged identifiers shouldn't have got this far -
	// remove the `replacement !== name` safeguard once that's the case
	if (replacement && replacement !== name && !scope.contains(name, true)) {
		// rewrite
		body.replace(node.start, node.end, replacement);
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/ast/replaceIdentifiers.js.01-babel.map